import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ClassesVideoSection } from '../components/ClassesVideoSection';
import { LibrarySection } from '../components/LibrarySection';
import { BonusesSection } from '../components/BonusesSection';
import { TransformationSection } from '../components/TransformationSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FaqSection } from '../components/FaqSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { Footer } from '../components/Footer';
import { PurchaseNotifications } from '../components/PurchaseNotifications';
export function Landing() {
  return <div className="w-full bg-ivory" data-id="element-265" data-mp="m8n1m1aqmm4x">
      <Hero data-id="element-266" data-mp="m5heuspkzwcd" />
      <main data-id="element-267" data-mp="2a0l6a3b6s8u">
        <ProblemSection data-id="element-268" data-mp="29sa8nqqxx0a" />
        <SolutionSection data-id="element-269" data-mp="2b3a4ch2mkm4" />
        <ClassesVideoSection data-id="element-270" data-mp="2bbpcb0o220h" />
        <LibrarySection data-id="element-271" data-mp="3tgbflndtcur7" />
        <BonusesSection data-id="element-272" data-mp="3tg20wvy7ya0t" />
        <TransformationSection data-id="element-273" data-mp="3tfjxnfd52vje" />
        <TestimonialsSection data-id="element-274" data-mp="3tio7as9dijhg" />
        <OfferSection data-id="element-275" data-mp="3pe81eqzrfc28" />
        <GuaranteeSection data-id="element-276" data-mp="3pfrmqw09wdav" />
        <FaqSection data-id="element-277" data-mp="3pezyy7cx3jv5" />
        <FinalCtaSection data-id="element-278" data-mp="3kfn16rkicsds" />
      </main>
      <Footer data-id="element-279" data-mp="3kgophxqjbbdg" />
      <PurchaseNotifications data-id="element-280" data-mp="3kgyebhzufchk" />
    </div>;
}